// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file CoordPointList.proto (package CoordPointList, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { CoordPoint } from "./CoordPoint_pb";
import { file_CoordPoint } from "./CoordPoint_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file CoordPointList.proto.
 */
export const file_CoordPointList: GenFile = /*@__PURE__*/
  fileDesc("ChRDb29yZFBvaW50TGlzdC5wcm90bxIOQ29vcmRQb2ludExpc3QiOgoOQ29vcmRQb2ludExpc3QSKAoIZW50aXRpZXMYASADKAsyFi5Db29yZFBvaW50LkNvb3JkUG9pbnRCRAotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQhNDb29yZFBvaW50TGlzdFByb3RvYgZwcm90bzM", [file_CoordPoint]);

/**
 * @generated from message CoordPointList.CoordPointList
 */
export type CoordPointList = Message<"CoordPointList.CoordPointList"> & {
  /**
   * @generated from field: repeated CoordPoint.CoordPoint entities = 1;
   */
  entities: CoordPoint[];
};

/**
 * Describes the message CoordPointList.CoordPointList.
 * Use `create(CoordPointListSchema)` to create a new message.
 */
export const CoordPointListSchema: GenMessage<CoordPointList> = /*@__PURE__*/
  messageDesc(file_CoordPointList, 0);

